import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HubLocationModal from "./component";
import { withRouter } from "react-router-dom";

const mapStateToProps = ({
    carDetails: {
        content: {cityCode}
    }
}) => ({
    cityCode
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HubLocationModal));
